import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  emoji: string;
  title: string;
  badge?: string;
  previewImage?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}
export function AccordionItem({
  emoji,
  title,
  badge,
  previewImage,
  defaultOpen = false,
  children
}: AccordionItemProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="overflow-hidden rounded-2xl border border-white/20 bg-[#101b2d]/95 shadow-lg shadow-black/20 backdrop-blur-md" data-id="element-14" data-mp="2n5s5unxepdu1">
      {previewImage && <img src={previewImage} alt={`${title} preview`} className="aspect-[16/7] w-full border-b border-white/15 object-cover" data-id="element-15" data-mp="2w43vonqg87lf" />}
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={`${open ? 'Collapse' : 'Expand'} ${title}`} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-16" data-mp="11pumoiq5utdu">
        <span className="text-2xl leading-none" aria-hidden data-id="element-17" data-mp="3g210fopfrvh7">
          {emoji}
        </span>
        <span className="flex-1" data-id="element-18" data-mp="3l145381i7zon">
          <span className="block font-display text-base font-700 leading-tight text-white" data-id="element-19" data-mp="3q1rsljqixye4">
            {title}
          </span>
          {badge && <span className="mt-1 inline-block rounded-full bg-[var(--pb-lime)]/15 px-2 py-0.5 text-xs font-600 text-[var(--pb-lime)]" data-id="element-20" data-mp="3uub7ck0y6zki">
              {badge}
            </span>}
        </span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="shrink-0 text-[var(--pb-lime)]" data-id="element-21" data-mp="7mhaayk2at6d">
          <ChevronDownIcon size={22} data-id="element-22" data-mp="hk41ajemyb6p" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-23" data-mp="2egl0x6mcvz7p">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} data-id="element-24" data-mp="2jd1pg1xgwflb">
            <div className="px-4 pb-4 pt-0" data-id="element-25" data-mp="2gb6w9hl9sikm">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}